  <!-- logo consentimiento -->
  <header class="header inlineflex">
    <div class="header_logo">
      <a [routerLink]="['']" class="tipo-white-color">
        <img
          alt="El consentimiento"
          src="../../../assets/img/header/logo-ELCI.png" />
      </a>
    </div>
     <div class="myaccount">
        <p class="company_name regular">{{user?.company}}</p>
        <p class="company_name small regular">{{user?.name}} {{user?.lastname}}</p>
           <button class="button tipo-white-color back-blue-color" (click)="logOut()">
              <fa-icon [icon]="faRightFromBracket" class="icono"></fa-icon>
              {{ 'PRIVATE.HEADER.BUTTON-UNLOG' | translate }}
           </button>
        </div>   
</header>  